export const NavigationRoutes = {
  AUTH_ROUTES: {
    INDEX: "/",
    LOGIN: "/login",
    REGISTER: "/register",
    RESET_PASSWORD: "/reset-password",
    FORGOT_PASSWORD: "/forgot-password",
    OTP_VERIFICATION: "/otp-verification",
  },
  DASHBOARD_ROUTES: {
    DASHBOARD: "/dashboard",
    USER_MANAGEMENT: "/user-management",
    USER_DETAILS: "/user-management/user-details",
    PROFILE_MANAGEMENT: "/profile-management",
    PROFILE_DETAILS: "/profile-management/profile-details",
    SUBSCRIPTION: '/subscription-management',
  },
};
